module.exports = __webpack_public_path__ + "img/大雪.669a827d.png";